import React, { useEffect, useState } from "react";
import { BASE_URL, IMG_URL } from "../config/api";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const BazarList = () => {
  const [bazarWorks, setBazarWorks] = useState([]);
  const [filteredBazarWorks, setFilteredBazarWorks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedWorkId, setSelectedWorkId] = useState(null);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}bazarworks`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setBazarWorks(data.data);
          setFilteredBazarWorks(data.data);
        } else {
          console.error("Failed to fetch data:", data.message);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    filterBazarWorks(term, startDate, endDate);
  };

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    filterBazarWorks(searchTerm, start, end);
  };

  const filterBazarWorks = (term, start, end) => {
    const filtered = bazarWorks.filter((work) => {
      const matchesSearch =
        work.title.toLowerCase().includes(term.toLowerCase()) ||
        work.description.toLowerCase().includes(term.toLowerCase());

      const workDate = new Date(work.date);
      const isInRange =
        (!start || workDate >= new Date(start)) &&
        (!end || workDate <= new Date(end));

      return matchesSearch && isInRange;
    });
    setFilteredBazarWorks(filtered);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleEdit = (id) => {
    navigate(`/EditBazarWork/${id}`);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This Bazar Work entry will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${BASE_URL}bazarworks/${id}`, {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === 1) {
              const updated = bazarWorks.filter((work) => work.id !== id);
              setBazarWorks(updated);
              setFilteredBazarWorks(updated);
              Swal.fire(
                "Deleted!",
                "The Bazar Work has been deleted.",
                "success"
              );
            } else {
              Swal.fire("Failed!", "Could not delete the entry.", "error");
            }
          })
          .catch((err) => {
            console.error("Delete error:", err);
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.text("Bazar Works List", 14, 10);
    const tableData = filteredBazarWorks.map((work) => [
      work.title || "N/A",
      work.description || "N/A",
      formatDate(work.date),
    ]);
    doc.autoTable({
      head: [["Title", "Description", "Date"]],
      body: tableData,
    });
    doc.save("bazar_works_list.pdf");
  };

  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredBazarWorks.map((work) => ({
        Title: work.title || "N/A",
        Description: work.description || "N/A",
        Date: formatDate(work.date),
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bazar Works List");
    XLSX.writeFile(workbook, "bazar_works_list.xlsx");
  };

  const openStatusModal = (id) => {
    setSelectedWorkId(id);
    setStatusModalOpen(true);
  };

  const closeStatusModal = () => {
    setStatusModalOpen(false);
  };

  const handleStatusChange = (status) => {
    fetch(`${BASE_URL}bazarworks/status/${selectedWorkId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          const updated = bazarWorks.map((work) =>
            work.id === selectedWorkId ? { ...work, status } : work
          );
          setBazarWorks(updated);
          setFilteredBazarWorks(updated);
          setStatusModalOpen(false);
        } else {
          Swal.fire("Error!", "Failed to update status.", "error");
        }
      })
      .catch((err) => {
        console.error("Status update error:", err);
        Swal.fire("Error!", "Something went wrong.", "error");
      });
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Bazar Works List</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-6"></div>
                  <div className="col-md-6 text-end">
                    {/* <button
                      className="btn btn-primary"
                      onClick={() => navigate("/AddBazar")}
                    >
                      Add Bazar Work
                    </button> */}
                    <button
                      className="btn btn-secondary ms-2"
                      onClick={handleExportPDF}
                    >
                      Export to PDF
                    </button>
                    <button
                      className="btn btn-secondary ms-2"
                      onClick={handleExportExcel}
                    >
                      Export to Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label className="form-label">Search</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Title or Description"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) =>
                        handleDateChange(e.target.value, endDate)
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) =>
                        handleDateChange(startDate, e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-lg">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Images</th>
                        <th className="text-end">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredBazarWorks.length > 0 ? (
                        filteredBazarWorks.map((work) => (
                          <tr key={work.id}>
                            <td>{work.title || "N/A"}</td>
                            <td>{work.description || "N/A"}</td>
                            <td>{formatDate(work.date)}</td>
                            <td>{work.status}</td>
                            <td>
                              {(() => {
                                let images = [];
                                try {
                                  images = Array.isArray(work.images)
                                    ? work.images
                                    : JSON.parse(work.images || "[]");
                                } catch (e) {
                                  console.error(
                                    "Image parse error:",
                                    work.images
                                  );
                                }

                                return images.length > 0 ? (
                                  images.map((img, index) => (
                                    <img
                                      key={index}
                                      src={`${IMG_URL}${img}`}
                                      alt={`Bazar Work ${index}`}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        margin: "5px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  ))
                                ) : (
                                  <span>No Images</span>
                                );
                              })()}
                            </td>
                            <td className="text-end">
                              {/* <button
                                className="btn btn-success"
                                onClick={() => handleEdit(work.id)}
                              >
                                Edit
                              </button> */}
                              <button
                                className="btn btn-danger ms-2"
                                onClick={() => handleDelete(work.id)}
                              >
                                Delete
                              </button>
                              <button
                                className="btn btn-warning ms-2"
                                onClick={() => openStatusModal(work.id)}
                              >
                                Status
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Bazar Works Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {statusModalOpen && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Change Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeStatusModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>Select Status:</p>
                <button
                  className="btn btn-outline-primary"
                  onClick={() => handleStatusChange("pending")}
                >
                  Pending
                </button>
                <button
                  className="btn btn-outline-success ms-2"
                  onClick={() => handleStatusChange("completed")}
                >
                  Completed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BazarList;
